const SkeletonCard = () => (
  <div className="w-[269px] h-[122px] p-2.5 rounded-lg bg-[#F5F5F5] animate-pulse space-y-5">
    <div className="flex space-x-2">
      <div className="w-11 h-11 bg-gray-300 rounded-[10px]" />
      <div className="space-y-2">
        <div className="w-24 h-3 bg-gray-300 rounded" />
        <div className="w-16 h-2 bg-gray-200 rounded" />
      </div>
    </div>
    <div className="w-1/2 h-3 bg-gray-300 rounded" />
  </div>
)

export default SkeletonCard